import Skeleton from "react-loading-skeleton"
import React from "react"
import "react-loading-skeleton/dist/skeleton.css"
import { colors } from "../../theme/colors"
import { Flex } from "rebass"
import "./styles.css"

export const RestaurantCardGhost = () => {
  return (
    <Flex width={"100%"}>
      <Skeleton
        height="240px"
        width="100%"
        count={1}
        containerClassName="flex-grow-1"
        baseColor={colors.ctaInactive}
        style={{ minWidth: "225px" }}
        borderRadius="8px"
      />
    </Flex>
  )
}
